export default __webpack_public_path__ + "static/media/E-commerceRealCase2-mobile.3ee9ffd6.jpg";